(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    function initStickyATC() {
    const mainAtcButton = document.querySelector('.product_qty_add_to_cart_btn .buy-btn-parent [name="add"]');
    const stickyBar = document.getElementById('sticky-atc-bar');
    const stickyCartBtn = document.getElementById('sticky-atc-button');
    const stickyAutoship = document.getElementById('sticky-autoship-button');

    if (!mainAtcButton || !stickyBar) return;
    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    stickyBar.style.display = 'block';

    const isSoldOut = mainAtcButton.disabled || 
                      document.querySelector('.product_qty_add_to_cart_btn.soldout_variant');

    const backInStockForm = document.querySelector('.backinstock-form');
    if (isMobile) {
      stickyBar.classList.add('is-visible');
      document.body.classList.add('sticky-atc-active');
    } else {
    const elementToObserve = (isSoldOut && backInStockForm) ? backInStockForm : mainAtcButton;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) {
            stickyBar.classList.add('is-visible');
            document.body.classList.add('sticky-atc-active');
          } else {
            stickyBar.classList.remove('is-visible');
            document.body.classList.remove('sticky-atc-active');
          }
        },
        { threshold: 0 }
      );

      observer.observe(elementToObserve);
    }

    // CTA click
    stickyCartBtn?.addEventListener('click', () => {
      if (isSoldOut && backInStockForm) {
        backInStockForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        mainAtcButton.click();
      }
    });

    stickyAutoship?.addEventListener('click', () => {
    const target = document.querySelector('.bsub-widget');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    });
  }

  document.addEventListener('DOMContentLoaded', initStickyATC);

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      requestAnimationFrame(() => initStickyATC());
    });
  }
  } catch(e) { console.error(e); }
})();

})();
